// extracted by mini-css-extract-plugin
module.exports = {"header":"style__header__sMGBT","headerImage":"style__headerImage__L70yc","headerText":"style__headerText__xwOEV"};